import { useCallback } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { TextField, ConfirmDialog, LinearProgress } from '@occc-app/design-system';

import { CreateLocationGroupFormValues } from './create-location-group-and-add-locations-dialog.types';
import { validate } from './create-location-group-and-add-locations-dialog.validation';

import { RetailerNetworkLocationMultipleSelectField } from '../../../components/retailer-network-location-multiple-select-field.component';

type CreateLocationGroupAndAddLocationsDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: CreateLocationGroupFormValues) => void;
  loading: boolean;
  retailerNetworkUuid: string;
};

export const CreateLocationGroupAndAddLocationsDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
  retailerNetworkUuid,
}: CreateLocationGroupAndAddLocationsDialogProps) => {
  const renderForm = useCallback<
    NonNullable<FormRenderProps<CreateLocationGroupFormValues>['render']>
  >(
    ({ handleSubmit, valid }) => {
      return (
        <ConfirmDialog
          dialogTitle='Add a Location Group'
          onClose={onClose}
          open={open}
          fullWidth
          maxWidth='sm'
          confirmButtonText='Add Group'
          confirmButtonProps={{
            onClick: handleSubmit,
            disabled: !valid || loading,
          }}
        >
          {loading && <LinearProgress />}
          <Box mt={1}>
            <TextField name='name' label='Location Group Name' />
            <RetailerNetworkLocationMultipleSelectField
              name='locations'
              label='Locations'
              retailerNetworkUuidEquals={retailerNetworkUuid}
            />
          </Box>
        </ConfirmDialog>
      );
    },
    [loading, onClose, open, retailerNetworkUuid],
  );

  return (
    <Form<CreateLocationGroupFormValues>
      onSubmit={onSubmit}
      validate={validate}
      render={renderForm}
    />
  );
};
